import { WorksheetReviewCondition, Worksheet, WorksheetTypeEnum } from '../../../../types/worksheet';
import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import { WorksheetChecklistItemStatusEnum } from '../../../../types/worksheet-checklist-item';
import { InternalCommentStatusEnum } from '../../../../types/internal-comment';
import { ClientQueryStatusEnum } from '../../../../types/client-query';
import ReviewConditionsList from './ReviewConditionsList';

function buildReviewConditionsList(worksheet: Worksheet): WorksheetReviewCondition[] {
    const conditions: { description: string; satisfied: boolean }[] = [
        {
            description: 'All internal comments must be resolved.',
            satisfied: worksheet.internalComments.every((ic) => ic.status === InternalCommentStatusEnum.RESOLVED),
        },
        {
            description: 'All client queries must be resolved.',
            satisfied: worksheet.clientQueries.every((cq) => cq.status === ClientQueryStatusEnum.RESOLVED),
        },
    ];

    if (worksheet.checklist.length > 0) {
        conditions.push({
            description: 'All checklist items must be resolved.',
            satisfied: worksheet.checklist.every((c) => c.status !== WorksheetChecklistItemStatusEnum.UNCHECKED),
        });
    }

    if (worksheet.type === WorksheetTypeEnum.RECONCILIATION) {
        conditions.push({
            description: 'The entries must reconcile to the account.',
            satisfied: !(worksheet.unreconciledCr || worksheet.unreconciledDr),
        });
    }

    return conditions;
}

type ReviewConditionsContainerProps = {
    worksheet: Worksheet;
};

function ReviewConditionsContainer({ worksheet }: ReviewConditionsContainerProps): JSX.Element {
    const conditions = buildReviewConditionsList(worksheet);
    const satisfiedCount = conditions.filter((c) => c.satisfied).length;

    return (
        <div className="flex flex-col gap-4 h-full">
            {/* TITLE */}
            <div className="flex items-center">
                <ClipboardDocumentCheckIcon className="h-5 w-5" />
                <p className="text-gray-800 ml-2 leading-4">
                    <span className="font-medium">
                        {satisfiedCount} of {conditions.length}{' '}
                    </span>
                    review conditions met
                </p>
            </div>
            <ReviewConditionsList conditions={conditions} />
        </div>
    );
}

export default ReviewConditionsContainer;
